import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash-es';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { LeaseDealsModel, LeaseDealsPaths } from 'client/data/models/lease-deals';
import { Button } from 'reactstrap';
import { FILTER_QUERY_PARAMS } from 'client/site-modules/shared/constants/lease-deals/lease-deals';

import './filters-button.scss';

function FiltersButtonUI({ onClick, selectedFilters = 0 }) {
  return (
    <Button
      className="filters-button d-flex align-items-center gap-0_5 text-transform-none text-white border-0 bg-transparent size-16 px-0 py-0_25"
      onClick={onClick}
    >
      <i className="icon-equalizer text-white" aria-hidden />
      <span className="fw-medium">Filters</span>
      {!!selectedFilters && (
        <>
          <span className="visually-hidden">Active:</span>
          <span className="custom-badge d-flex justify-content-center align-items-center rounded-circle bg-turquoise-80 text-turquoise-05 fw-bold lh-1">
            {selectedFilters}
          </span>
        </>
      )}
    </Button>
  );
}

FiltersButtonUI.propTypes = {
  onClick: PropTypes.func.isRequired,
  selectedFilters: PropTypes.number,
};

const getSelectedFiltersCount = filters => {
  return Object.entries(filters).reduce((count, [filterName, filterValues]) => {
    switch (filterName) {
      case FILTER_QUERY_PARAMS.PAGE_NUM:
      case FILTER_QUERY_PARAMS.SORT_BY:
      case FILTER_QUERY_PARAMS.DEALS:
      case FILTER_QUERY_PARAMS.ID:
      case FILTER_QUERY_PARAMS.EDMUNDS_TYPE_CATEGORIES:
        return count;
      case FILTER_QUERY_PARAMS.MONTHLY_PAYMENT:
        return filterValues.filter(value => value !== null).length ? count + 1 : count;

      default:
        return isEmpty(filterValues) ? count : count + 1;
    }
  }, 0);
};

const stateToPropsConfig = {
  selectedFilters: bindToPath(
    LeaseDealsPaths.getSelectedFiltersPath(),
    LeaseDealsModel,
    getSelectedFiltersCount,
    false
  ),
};

export const FiltersButton = connectToModel(FiltersButtonUI, stateToPropsConfig);
